import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import EnergyAdvice from "./sections/EnergyAdvice";
import Services from "./sections/Services";
import Voucher from "./sections/Voucher";
import Upload from "./sections/Upload";
import Spendless from "./sections/Spendless";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <EnergyAdvice />
      <Services />
      <Voucher />
      <Upload />
      <Spendless />
      <Footer />
    </div>;
}